import React from 'react';

import {BaseMainTitle} from "../base-title/base.main-title";
import {BaseSideTitle} from "../base-title/base.side-title";
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "./widget-wrapper.module.scss"
import {TAG_TITLE} from "../../../app/consts";

export const WidgetWrapperTitle = observer(({
                                              controller,
                                              title,
                                              bookmaker,
                                              className,
                                              ElementComponent,
                                              source,
                                              currentLinkModel,
                                              sportTypeId,
                                              titleTag: titleTagProps
                                            }) => {
  const titleTag: String = titleTagProps || (controller?.device?.isSmallView ? TAG_TITLE.h2 : TAG_TITLE.h3);

  const containerProps = {
    className: classNames(styles.title_container,
      {[styles.small_view]: controller?.device?.isSmallView},
      className
    ),
  }

  const mainProps = {
    title,
    controller,
    className: styles.title,
    TitleTag: titleTag,
    source
  }

  const sideProps = {
    controller,
    bookmaker,
    ElementComponent,
    source,
    currentLinkModel,
    sportTypeId
  }

  return (
    title?.length > 0 ? <div {...containerProps}>
      <BaseMainTitle {...mainProps}/>
      <BaseSideTitle {...sideProps}/>
    </div> : null
  );
});

